import * as React from "react";

/**
 * An element's width in CSS pixels, again whenever it changes (a ResizeObserver): the record's tab bar measures the
 * room it has, so the tabs that don't fit go under More ▾. Null until measured, and where the platform has no
 * ResizeObserver (a unit test's DOM).
 */
export function useElementWidth<T extends HTMLElement>(): [
  (element: T | null) => void,
  number | null,
] {
  const [width, setWidth] = React.useState<number | null>(null);
  const observer = React.useRef<ResizeObserver | null>(null);
  const ref = React.useCallback((element: T | null) => {
    observer.current?.disconnect();
    observer.current = null;
    if (!element || typeof ResizeObserver === "undefined") return;
    const next = new ResizeObserver((entries) => {
      const box = entries[0]?.contentRect;
      if (box) setWidth(Math.floor(box.width));
    });
    next.observe(element);
    observer.current = next;
  }, []);
  return [ref, width];
}
